import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isMobile, isTablet } from 'react-device-detect'; // 모바일 판단을 위해 추가

const ProtectedRoute = ({ children }) => {
  const userRank = localStorage.getItem("userRank");
  const location = useLocation();
  const pathname = location.pathname;

  // 1. [신규 로직] userRank가 '0' 또는 '9'인 경우 모바일 리다이렉트 체크
  if (userRank === "0" || userRank === "9") {
    if (isMobile || isTablet) {
      const restrictedCustomerPaths = [
        "/customer/status",
        "/customer/trends",
        "/customer/complaint",
        "/customer/complaint/write"
      ];

      // 제한된 고객용 URL에 접근 시 /client/state로 리다이렉트
      if (restrictedCustomerPaths.includes(pathname)) {
        return <Navigate to="/client/state" replace />;
      }
    }
  }

  // userRank === '2'인 경우 허용 URL
  const allowedPaths = [
    "/login",
    "/signup", // 취합된 리스트 기반 추가
    "/signin",
    "/customer/status",
    "/customer/trends",
    "/customer/complaint",
    "/customer/complaint/write",
    "/customer/notice", // App.js 기준 notification -> notice 확인 필요
    "/info",
    "/info/privacy",
    "/info/support",
    "/info/tob/support",
    "/customer/complaint/detail",
    "/customer/service",
    "/password",
  ];

  // userRank === '3'인 경우 허용 URL
  const allowedDummyPaths = [
    "/login",
    "/signup",
    "/info",
    "/signin",
    "/info/privacy",
    "/info/support",
    "/info/tob/support",
    "/customer/service",
    "/customer/service/commercial",
    "/customer/service/residential",
    "/customer/consult", // 와일드카드 처리를 위해 베이스 경로만 지정
    "/password",
  ];

  // 와일드카드(*)를 고려한 경로 검증 로직 (Rank 3 전용)
  const isAllowedRank3 = allowedDummyPaths.some(path => {
    if (path === pathname) return true;
    if (path === "/customer/consult") {
      return pathname.startsWith("/customer/consult/");
    }
    return false;
  });

  // 2. 권한별 리다이렉트 처리
  if (!userRank) {
    if (!allowedPaths.includes(pathname) && pathname !== "/login" && pathname !== "/signup") {
      return <Navigate to="/login" replace />;
    }
  }

  if (userRank === "2") {
    if (!allowedPaths.includes(pathname)) {
      return <Navigate to="/customer/status" replace />;
    }
  }

  if (userRank === "3") {
    if (!isAllowedRank3) {
      return <Navigate to="/customer/service" replace />;
    }
  }

  // 3. 관리자 및 기타 권한 (0, 9 등)은 기본 children 렌더링
  return children;
};

export default ProtectedRoute;
